// extracted by mini-css-extract-plugin
export var discountChip = "CustomPromoBanner-module--discountChip--70457";
export var headerContainer = "CustomPromoBanner-module--header-container--3ce92";